import styled from "styled-components";

interface IContainer {
  marginTop?: number;
}

export const Container = styled.div<IContainer>`
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  background-color: ${({ theme }) => theme.colors.surface.surface};
  margin-top: ${({ marginTop }) => marginTop || 0}px;
`;

export const Title = styled.div`
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`;

export const Toolbar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  .searchBox {
    flex: 1;
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  }

  .toolbarBtn {
    display: flex;
    align-items: center;
    height: 40px !important;
    flex-shrink: 0;

    .actionIcon {
      color: ${({ theme }) => theme.colors.secondary.onSecondary} !important;
    }

    .textBtn {
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.secondary.onSecondary};
      margin-left: 6px;
    }

    &:disabled {
      .actionIcon, .textBtn {
        color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder} !important;
      }
    }
  }
`;

export const HeaderContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 20px;

  .column1 {
    width: 48px;
    display: flex;
    justify-content: center;
  }
  .column2 {
    width: 90px;
  }
  .column3 {
    width: 30%;
  }
  .column4 {
    flex: 1;
  }
  .column5 {
    width: 90px;
  }

  .columnText {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EmptyList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0;

  .title {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    margin-bottom: 6px;
  }

  .text {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    margin-bottom: 16px;
  }
`;
